import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, tap, of, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class ApiTokenInterceptorInterceptor implements HttpInterceptor {

unauthorizedUrl = '/invalid-permissions';
  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
  {
    // console.log (` am in interceptor ${JSON.stringify(request)}`);

    if (request.url === '/ocmapi/passport'){
        return next.handle(request).pipe(
          tap(event => {
            if (event instanceof HttpResponse) {
                const modifiedData = event.body.passportid;
                sessionStorage.setItem('passportid', modifiedData);
            } 
          })
        )
    } else {
      let passportid = sessionStorage.getItem('passportid');
      if (passportid) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${passportid}`
            }
          });
      } else {
        return next.handle(request).pipe(
          catchError((error: HttpErrorResponse) => {
              if (error.status === 403) {
                this.router.navigate(['/']);
              }
              return of(new HttpResponse({
                status: error.status,
                statusText: error.statusText,
                headers: error.headers
              }));
          }));
      }

    }
    //return next.handle(request);
   
     return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // console.log (`interceptor catchError ${JSON.stringify(error)} `)
        if (this.isUnauthorized(error.status)) {
          this.router.navigate([this.unauthorizedUrl]);
          return of(new HttpResponse({
            status: error.status,
            statusText: error.statusText,
            headers: error.headers,
         
          }));
        } else {
          // console.log (`interceptbefore throwError ${JSON.stringify(error)}`)
          if (error.error.ErrorMessage !== null && typeof error.error.ErrorMessage === "string" && error.error.ErrorMessage.indexOf("User Already") !== -1) {
            return next.handle(request);
          }
          return throwError(() => error.error)
        }
    })); 

    
  }

  private isUnauthorized(status: number): boolean {
    return status === 403;
  }

}
